import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  swalErrorIcon,
  swalInfoIcon,
  swalSuccessIcon,
  swalWarningIcon,
} from "@/icons/statusIcons";
import { codeResponsive } from "@/views/components/image/code";

export default {
  data() {
    return {};
  },
  computed: {
    isDarkSkin() {
      return this.$store.getters["appConfig/skin"] === "dark";
    },
    bgTabsNavs() {
      //getters
      return this.$store.getters["appConfig/skin"] === "dark"
        ? "nav-dark-tabs"
        : "nav-light-tabs";
    },
    textLink() {
      return this.$store.getters["appConfig/skin"] === "dark"
        ? "text-warning font-weight-bolder"
        : "text-primary font-weight-bolder";
    },
    isCeo() {
      return this.$store.getters["auth/isCeo"];
    },
    isChief() {
      return this.$store.getters["auth/isChief"]
    }
  },
  methods: {

    showToast(
      variant = "success",
      position = "top-right",
      title = "Congratulations",
      icon = "BellIcon",
      text = "Error in Transaction!"
    ) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.$t(title),
            icon,
            text: this.$t(text),
            variant,
          },
        },
        {
          position,
        }
      );
    },

    showToastError(
      text = "Error in Transaction!",
      title = "Error"
    ) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.$t(title),
            icon: "BellIcon",
            text: this.$t(text),
            variant: "danger",
          },
        },
        {
          position: "top-right",
        }
      );
    },

    showToastWarning(
      text = "Error in Transaction!",
      title = "Warning"
    ) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.$t(title),
            icon: "BellIcon",
            text: this.$t(text),
            variant: "warning",
          },
        },
        {
          position: "top-right",
        }
      );
    },

    showToastSuccess(
      text = "Transaction Success!",
      title = "Success"
    ) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.$t(title),
            icon: "BellIcon",
            text: this.$t(text),
            variant: "success",
          },
        },
        {
          position: "top-right",
        }
      );
    },

    showConfirmSwal(
      title = this.$t("Are you sure?"),
      text = this.$t("You won't be able to revert this!"),
      config = {}
    ) {
      return this.$swal({
        title,
        text,
        imageUrl: swalWarningIcon,
        imageWidth: 70,
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: config.confirmButtonText || this.$t("Yes"),
        cancelButtonText: config.cancelButtonText || this.$t("Cancel"),
        customClass: {
          confirmButton: "btn btn-primary mr-1",
          cancelButton: "btn btn-outline-danger",
          ...(config.customClass || {}),
        },
        ...config,
      });
    },

    async forceFileDownload(response, nameExcel, type = null) {
      const url = window.URL.createObjectURL(
        new Blob([response], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      if (type == "blank") {
        link.setAttribute("target", "_blank");
      } else {
        link.setAttribute("download", nameExcel);
      }
      document.body.appendChild(link);
      link.click();
    },

    async forceFileDownloadPdf(response, type = 'download') {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/pdf",
        })
      );
      const link = document.createElement("a");
      const filename = this.getFilename(response.headers['content-disposition']) || 'file.pdf';
      link.href = url;

      if (type == "blank") {
        link.setAttribute("target", "_blank");
      } else {
        link.setAttribute("download", filename);
      }

      document.body.appendChild(link);
      link.click();
    },

    getFilename(header) {
      let startFileNameIndex = header.indexOf('"') + 1;
      let endFileNameIndex = header.lastIndexOf('"');
      let filename = header.substring(startFileNameIndex, endFileNameIndex);
      return filename;
    },

    getNameOfMonth(numberOfMonth) {
      switch (numberOfMonth) {
        case 1:
          return this.$t('january')
        case 2:
          return this.$t('february')
        case 3:
          return this.$t('march')
        case 4:
          return this.$t('april')
        case 5:
          return this.$t('may')
        case 6:
          return this.$t('june')
        case 7:
          return this.$t('july')
        case 8:
          return this.$t('august')
        case 9:
          return this.$t('september')
        case 10:
          return this.$t('october')
        case 11:
          return this.$t('november')
        case 12:
          return this.$t('december')

      }
    },

    showMessageAlert(
      title = "Are you sure?",
      subtitle = "You won't be able to revert this!",
      data = [{ isFeather: true, icon: 'KeyIcon', title: 'CODE', description: 'Fino' }],
      ok = () => {
        alert("ok");
      },
      okTitle = "OK",
      icon = "KeyIcon",
    ) {

      this.$MessageAlert({
        title,
        subtitle,
        data,
        okTitle,
        ok,
        icon
      })
    },

  },
};
